export default [{
  value: 0,
  label: 'msg_codes_agreementStatus_active',
}, {
  value: 3,
  label: 'msg_codes_agreementStatus_inactive',
}];
